<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="2">
        <v-btn color="primary" @click="register()" block>+</v-btn>
      </v-col>
      <v-col cols="12" sm="4" class="d-flex align-center">
        <v-chip color="info" outlined>
          <v-icon left small>mdi-account-multiple</v-icon>
          {{ counter }} registros
        </v-chip>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Código</th>
          <th>Caminho</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.nome }}</td>
          <td>{{ item.codigo }}</td>
          <td>{{ item.caminho }}</td>
          <td>
            <v-btn icon @click="edit(item.id)"><v-icon>mdi-magnify</v-icon></v-btn>
            <v-btn icon @click="confirmDelete(item)"><v-icon color="error">mdi-delete</v-icon></v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_confirm" width="400">
      <v-card>
        <v-card-title>Confirmar exclusão</v-card-title>
        <v-card-text>
          Deseja realmente excluir o afiliado
          <strong>{{ selected.nome }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_confirm = false">Cancelar</v-btn>
          <v-btn color="error" text @click="remove()">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import router from "../../router/index.js";
import api from "../../api/index.js";
export default {
  data: () => ({
    current: null,
    counter: 0,
    dialog_loading: false,
    dialog_confirm: false,
    selected: {},
  }),
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      me.current = [];
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/afiliado", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
          me.counter = response.data.length;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registros!");
          console.log(error);
        });
    },
    register: function () {
      router.push({ path: `/afiliado/0` });
    },
    edit: function (id) {
      router.push({ path: `/afiliado/${id}` });
    },
    confirmDelete: function (item) {
      this.selected = item;
      this.dialog_confirm = true;
    },
    remove: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_confirm = false;
      me.dialog_loading = true;
      api
        .delete("/afiliado/" + me.selected.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          me.dialog_loading = false;
          me.load();
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao excluir registro!");
          console.log(error);
        });
    }
  }
};
</script>